import script from "./AutoSaveBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoSaveBanner.vue?vue&type=script&setup=true&lang=ts"

import "./AutoSaveBanner.vue?vue&type=style&index=0&id=04be3a67&lang=scss"

const __exports__ = script;

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QIcon,QBtn,QTooltip});
